import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom'
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { useAppDispatch } from "../hooks";
import { loadSchema } from "../redux/slices/page";

export function Default() {
  const { app, page } = useSelector((state: any) => state);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const pageId = (app.navigationItems.find((item: any) => item.path === location.pathname) || {id:''}).id;

  useEffect(() => {
    switch (page.loadingStatus) {
      case "none": {
        //dispatch(loadSchema(pageId));
        break;
      }
      case "done": {
        break;
      }
      default:
        break;
    }
  }, [app.loadingStatus]);

  return (
    <Box>
        <Typography variant="h3">
        </Typography>
    </Box>
  );
}
